import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from 'components/Button/Button';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import appHelpers from 'utils/app-urls';
import messages from '../messages';

const cdnURL = appHelpers.getCDNUrl();

export const Route = createFileRoute('/auth/reset-password/sent')({
  component: ResetEmail,
});

export default function ResetEmail() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );
  const navigate = useNavigate();
  const [countdown, _] = useSecondsCountdown(5, {
    onElapsed: () => {
      navigate({ to: '/auth/login' });
    },
  });

  const resetEmailMessages = messages[language].resetEmail;

  return (
    <div className="bg-ghost-white py-2">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <img
          src={`${cdnURL}assets/register/check-your-email.png`}
          alt={resetEmailMessages.umbrellaHandAlt}
          className="center"
        />
        <h2 className="font-semibold leading-9 m-6 text-2xl text-black text-center">
          {resetEmailMessages.heading}
        </h2>
        <p className="text-lg text-gray-900">
          {resetEmailMessages.bodyTop}
          <br />
          <br />
          {resetEmailMessages.bodyBottom}&nbsp;
          <span className="font-semibold text-black">
            {resetEmailMessages.bodyCountdown(countdown)}
          </span>
        </p>
      </div>

      <div className="mt-12 mb-6">
        <span className="block m-auto max-w-lg rounded-md w-full">
          <Button
            onClick={() => navigate({ to: '/auth/login' })}
            w-full
            flex
            justify-center
            py-2
            px-4
            border
            border-transparent
            text-sm
            font-normal
            rounded-md
            text-white
            transition
            duration-150
            ease-in-out
            bg-vivid-blue>
            {resetEmailMessages.continueButton}
          </Button>
        </span>
      </div>
    </div>
  );
}

function useSecondsCountdown(
  initialValue: number,
  { onElapsed }: { onElapsed?: () => void },
) {
  const [countdown, setCountdown] = useState(initialValue);

  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else {
      onElapsed?.();
    }
  }, [countdown]);

  return [countdown, { restart: () => setCountdown(initialValue) }] as const;
}
